"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPromoNotificationMetadataToJSON = exports.NftPromoNotificationMetadataFromJSONTyped = exports.NftPromoNotificationMetadataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftPromoNotificationMetadataFromJSON(json) {
    return NftPromoNotificationMetadataFromJSONTyped(json, false);
}
exports.NftPromoNotificationMetadataFromJSON = NftPromoNotificationMetadataFromJSON;
function NftPromoNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftUri': json['nftUri'],
        'mintDate': json['mintDate'],
        'description': json['description'],
        'notificationType': !(0, runtime_1.exists)(json, 'notificationType') ? undefined : (0, _1.NotificationTypeFromJSON)(json['notificationType']),
    };
}
exports.NftPromoNotificationMetadataFromJSONTyped = NftPromoNotificationMetadataFromJSONTyped;
function NftPromoNotificationMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftUri': value.nftUri,
        'mintDate': value.mintDate,
        'description': value.description,
        'notificationType': (0, _1.NotificationTypeToJSON)(value.notificationType),
    };
}
exports.NftPromoNotificationMetadataToJSON = NftPromoNotificationMetadataToJSON;
